/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Logger from "js-logger";
import { useMutation } from "@apollo/client";

// eslint-disable-next-line no-unused-vars
import styles from "./EditBlockWebModal.module.scss";
import { useHotkey } from "../../../Utils/Hotkeys";
import BaseModal, { useBaseModal } from "../BaseModal/BaseModal";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import { FETCH_WEB_LINK } from "../../../GraphQl/webLinks";
import EditBlockWeb from "./EditBlockWeb/EditBlockWeb";

const propTypes = {
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

const defaultProps = {
  onOpen: () => {},
  onClose: () => {},
};

const useEditBlockWebModal = ({ onOpen, onClose }) => {
  const [block, setBlock] = useState(null);
  const { isOpened, open, close } = useBaseModal({
    onOpen,
    onClose: () => {
      onClose();
    },
  });

  const openModal = (existingBlock) => {
    setBlock(existingBlock);
    open();
  };

  const closeModal = () => {
    close();
    setBlock(null);
  };

  let content = null;
  if (isOpened && block) {
    let innerContent = <EditBlockWeb block={block} onCloseModal={closeModal} />;

    content = (
      <BaseModal show={isOpened} onCloseHandler={closeModal}>
        {innerContent}
      </BaseModal>
    );
  }

  return { open: openModal, close: closeModal, content };
};

useEditBlockWebModal.propTypes = propTypes;
useEditBlockWebModal.defaultProps = defaultProps;

export default useEditBlockWebModal;
